var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-mask',{staticClass:"form-control",attrs:{"placeholder":_vm.phoneMask,"mask":_vm.phoneMask,"disabled":!this.country},model:{value:(_vm.formattedPhone),callback:function ($$v) {_vm.formattedPhone=$$v},expression:"formattedPhone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }